import type { ReactNode } from 'react';
import type { ExerciseKind } from '@features/Session';

const paths: Record<
  ExerciseKind | 'shuffle' | 'check' | 'cards' | 'arrow' | 'spark' | 'settings' | 'chevron',
  ReactNode
> = {
  settings: (
    <>
      <path d="M4 7h3m4 0h9M4 17h9m4 0h3" />
      <circle cx="9" cy="7" r="2" />
      <circle cx="15" cy="17" r="2" />
    </>
  ),
  chevron: <path d="m6 9 6 6 6-6" />,
  input: <path d="M4 12h14M13 6l6 6-6 6" />,
  reverse: <path d="M20 12H6M11 6l-6 6 6 6" />,
  mcq: (
    <>
      <rect x="3" y="4" width="7" height="7" rx="1.5" />
      <rect x="14" y="4" width="7" height="7" rx="1.5" />
      <rect x="3" y="15" width="7" height="6" rx="1.5" />
      <path d="m14 17 2 2 5-5" />
    </>
  ),
  cloze: (
    <>
      <path d="M4 6h16M4 12h6M4 18h13" />
      <rect x="13" y="10" width="7" height="4" rx="1" />
    </>
  ),
  shuffle: (
    <>
      <path d="M3 6h3c5 0 7 12 12 12h3m-4-4 4 4-4 4M3 18h3c2 0 3-2 4-4m4-4c1-2 2-4 4-4h3m-4-4 4 4-4 4" />
    </>
  ),
  check: <path d="m5 12 4 4L19 6" />,
  cards: (
    <>
      <rect x="3" y="3" width="14" height="13" rx="2" />
      <path d="M7 21h12a2 2 0 0 0 2-2V8" />
    </>
  ),
  arrow: <path d="M4 12h16m-6-6 6 6-6 6" />,
  spark: <path d="m12 3 2.8 6.2L21 12l-6.2 2.8L12 21l-2.8-6.2L3 12l6.2-2.8L12 3Z" />,
};

export function BuilderIcon({ name }: { name: keyof typeof paths }) {
  return (
    <svg
      aria-hidden="true"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {paths[name]}
    </svg>
  );
}
